module.exports = __webpack_public_path__ + "bb36776da5aca6031279acdf469a6fd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-4.jpg
// module id = 393
// module chunks = 0